// removed by extract-text-webpack-plugin
module.exports = {"Container":"dashboardBoxList__Container__2CEF0","ContentBox":"dashboardBoxList__ContentBox__18u_A","ResultsMessage":"dashboardBoxList__ResultsMessage__3om0V"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/DashboardBoxList/dashboardBoxList.css
// module id = 1263
// module chunks = 2